import { ChecklistNotificationItem } from 'layout/inbox-notifications/close/checklist/ChecklistNotificationItem';
import { ReconciliationNotificationItem } from 'layout/inbox-notifications/close/reconciliation/ReconciliationNotificationItem';

import type { ChecklistNotification } from 'types/inbox-notifications/close/ChecklistNotifications';
import type { CloseNotification } from 'types/inbox-notifications/close/CloseNotification';
import type { ReconciliationNotification } from 'types/inbox-notifications/close/ReconciliationNotifications';

export function CloseNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: CloseNotification;
}) {
  const [submodule, ...restOfType] = type;

  switch (submodule) {
    case 'checklist':
      return (
        <ChecklistNotificationItem
          type={restOfType}
          item={item as ChecklistNotification}
        />
      );
    case 'reconciliation':
      return (
        <ReconciliationNotificationItem
          type={restOfType}
          item={item as ReconciliationNotification}
        />
      );
    default:
      return <div>Unknown close notification type: {type.join('.')}</div>;
  }
}
